export const NAVBAR_HEIGHT = 65;
export const DRAWER_WIDTH = 256;

export const MOBILE_VIEW_BREAKPOINT = 600;

export const API_BASE_URL = 'https://us-central1-jyp-admin-saas.cloudfunctions.net';



// WEBPACK FOOTER //
// ./src/styles/constant.js